export interface AuthConfig {
  issuer: string;
  clientId: string;
  redirectUri: string;
}

export class OktaAuthConfig {
  constructor(public config: AuthConfig) {}
}
